export default "__VITE_ASSET__BlAWsnW4__"